
import { Component, Prop, Vue } from 'vue-property-decorator';
import EscapeHTML from '@/util/Sanitization';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

library.add(faTimes);

@Component({})
export default class QueueManage extends Vue {
	@Prop({ required: true })
	type!: 'ordered' | 'appointments';

	@Prop({ required: true })
	defaultConfiguration!: { [index: string]: any };

	configuration: { [index: string]: any } = {};

	@Prop({ required: true })
	defaultGroups!: string[][];

	groups: string[][] = [];

	groupsInput = '';
	promptsInput = '';

	constructor() {
		super();
		this.configuration = { ...this.defaultConfiguration };
		this.promptsInput =
			this.configuration.prompts.length > 0
				? JSON.stringify(this.configuration.prompts, null, 2)
				: '';
		for (let i = 0; i < this.defaultGroups.length; i++) {
			this.groups.push([...this.defaultGroups[i]]);
		}
	}

	addAnnouncement() {
		this.$buefy.dialog.prompt({
			message: 'Announcement content:',
			confirmText: 'Add Announcement',
			onConfirm: (content) => this.$emit('announcementAdded', content),
		});
	}

	groupsPlaceholder = [
		['member 1 of group 1', 'member 2 of group 1'],
		['member 1 of group 2', 'member 2 of group 2', 'member 3 of group 2'],
		['only member of group 3'],
	];

	validateGroupsArray(obj: any, currentGroups: string[][]): boolean {
		if (!Array.isArray(obj)) {
			this.$buefy.dialog.alert({
				message: 'Input does not contain array of arrays of strings.',
				type: 'is-danger',
			});
			return false;
		}
		const emailsSeen = new Set<string>();
		for (const g of currentGroups) {
			for (const e of g) {
				emailsSeen.add(e);
			}
		}
		for (const g of obj) {
			if (!Array.isArray(g)) {
				this.$buefy.dialog.alert({
					message: 'Input does not contain array of arrays of strings.',
					type: 'is-danger',
				});
				return false;
			}
			for (const e of g) {
				if (typeof e !== 'string') {
					this.$buefy.dialog.alert({
						message: 'Input contains a non-string email.',
						type: 'is-danger',
					});
					return false;
				}
				if (emailsSeen.has(e)) {
					this.$buefy.dialog.alert({
						message: `Email ${EscapeHTML(e)} appears in more than one group!`,
						type: 'is-danger',
					});
					return false;
				}
				emailsSeen.add(e);
			}
		}

		return true;
	}

	addGroups() {
		try {
			const groups = JSON.parse(this.groupsInput);
			if (!this.validateGroupsArray(groups, this.groups)) {
				return;
			}
			for (const g of groups) {
				this.groups.push([...g]);
			}
		} catch {
			this.$buefy.dialog.alert({
				message: 'Input is not valid JSON.',
				type: 'is-danger',
			});
		}
	}

	setGroups() {
		try {
			const groups = JSON.parse(this.groupsInput);
			if (!this.validateGroupsArray(groups, [])) {
				return;
			}
			this.groups = [];
			for (const g of groups) {
				this.groups.push([...g]);
			}
		} catch {
			this.$buefy.dialog.alert({
				message: 'Input is not valid JSON.',
				type: 'is-danger',
			});
		}
	}

	removeGroup(i: number) {
		this.groups.splice(i, 1);
	}

	removeMember(i: number, email: string) {
		this.groups.splice(
			i,
			1,
			this.groups[i].filter((e) => e !== email)
		);

		if (this.groups[i].length === 0) {
			this.removeGroup(i);
		}
	}
}
